import { ApiFehler } from '../api';

/**
 * Die Felder, wie sie der Mensch kennt – nicht, wie sie im Vertrag heißen.
 * `positionen.2.menge` ist für den Techniker „Position 3, Menge".
 */
const FELD_TEXT: Record<string, string> = {
  datum: 'Datum',
  einsatzort: 'Einsatzort',
  ansprechpartner: 'Ansprechpartner',
  taetigkeit: 'Ausgeführte Arbeiten',
  bemerkung: 'Bemerkung',
  positionen: 'Positionen',
  art: 'Art',
  bezeichnung: 'Bezeichnung',
  menge: 'Menge',
  einheit: 'Einheit',
  von: 'von',
  bis: 'bis',
  artikelId: 'Artikel',
  taetigkeitsartId: 'verrechnet als',
  auftragspositionNummer: 'Auftragsposition',
  name: 'Name',
  bild: 'Unterschrift',
  grund: 'Grund',
  notiz: 'Notiz',
};

/** `['positionen', 2, 'menge']` → „Position 3, Menge". */
export function stelleLesbar(pfad: unknown[]): string {
  const teile: string[] = [];

  for (let i = 0; i < pfad.length; i++) {
    const teil = pfad[i];

    if (teil === 'positionen' && typeof pfad[i + 1] === 'number') {
      teile.push(`Position ${Number(pfad[i + 1]) + 1}`);
      i++;
    } else if (typeof teil === 'string') {
      teile.push(FELD_TEXT[teil] ?? teil);
    } else {
      teile.push(String(teil));
    }
  }

  return teile.join(', ');
}

/** Eine Fehlermeldung, wie die API sie sagt – mit den Stellen, wenn sie welche nennt. */
export function meldungAus(fehler: unknown): string {
  if (fehler instanceof ApiFehler) {
    if (Array.isArray(fehler.details)) {
      const stellen = (fehler.details as { path?: unknown[]; message?: string }[])
        .slice(0, 3)
        .map((d) => {
          const stelle = stelleLesbar(d.path ?? []);

          return stelle ? `${stelle}: ${d.message ?? ''}` : (d.message ?? '');
        })
        .join('; ');

      return `${fehler.message} ${stellen}`;
    }

    return fehler.message;
  }

  return fehler instanceof Error ? fehler.message : 'Unerwarteter Fehler.';
}

export function Fehler({ fehler }: { fehler: unknown }) {
  return fehler ? (
    <p className="mb-4 rounded border border-rose-300 bg-rose-50 px-3 py-2 text-rose-900">
      {meldungAus(fehler)}
    </p>
  ) : null;
}
